import { Models, RematchDispatch } from "@rematch/core";
import { configurationPluginLoader } from "./configurationPluginLoader";
import { configurationPluginData } from "./configurationPluginData";
import { configurations } from "./configurations";
import { desktopConfigsModel } from "./desktopConfigs";
import { dynamicLabelsModel } from "./dynamicLabels";
import { notificationsModel } from "./notifications";
import { pinnedAppsModel } from "./pinnedApps";
import { pluginsCustomDataModel } from "./pluginsCustomData";
import { sessionConfigsModel } from "./sessionConfigs";
import { componentsModel } from "./components";

export type ConfigurationPluginLoaderModel = typeof configurationPluginLoader;
export type ConfigurationPluginDataModel = typeof configurationPluginData;
export type ConfigurationsModel = typeof configurations;
export type DesktopConfigsModel = typeof desktopConfigsModel;
export type DynamicLabels = typeof dynamicLabelsModel;
export type NotificationsModel = typeof notificationsModel;
export type PinnedAppsModel = typeof pinnedAppsModel;
export type PluginsCustomDataModel = typeof pluginsCustomDataModel;
export type SessionConfigsModel = typeof sessionConfigsModel;
export type ComponentsModel = typeof componentsModel;

export interface KoreModel extends Models<KoreModel> {
  configurationPluginLoader: ConfigurationPluginLoaderModel;
  configurationPluginData: ConfigurationPluginDataModel;
  configurations: ConfigurationsModel;
  desktopConfigs: DesktopConfigsModel;
  dynamicLabels: DynamicLabels;
  notifications: NotificationsModel;
  pinnedApps: PinnedAppsModel;
  pluginsCustomData: PluginsCustomDataModel;
  sessionConfigs: SessionConfigsModel;
  components: ComponentsModel;
}

export type KoreDispatch = RematchDispatch<KoreModel>;

export default {
  configurationPluginLoader,
  configurationPluginData,
  configurations,
  desktopConfigsModel,
  dynamicLabelsModel,
  notificationsModel,
  pinnedAppsModel,
  pluginsCustomDataModel,
  sessionConfigsModel,
  componentsModel
};
